module.exports = __webpack_public_path__ + "img/pool_cleaner.b176d592.jpg";